import { MappingEntry } from "./mappingEntry";

export class MappingTable {
    id: string;
    merchantId : number;
    name : string;
    posExternalRef : string;
    mappingEntries: Array<MappingEntry>;
}
